export const phoneRegex = /^(\+)?(\(?\d+\)?)(([\s-]+)?(\d+)){0,}$/g
export const websiteRegex = /^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?\/?$/g
export const numberRegex = /^\d+$/g